import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NewsEditFormData } from './news/news-edit/news-edit.component';
import { AuthService } from './auth.service';
import { API_URL } from './base/interfaces';
import { AngularFirestore, CollectionReference, fromDocRef, Query } from '@angular/fire/firestore';
import { News } from './shared/intefaces/news';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  url = `${API_URL}news`;

  constructor(private http: HttpClient, private auth: AuthService, private firestore: AngularFirestore) { }

  get options(): any {
    return {
      'headers': {
        'Authorization': `Bearer${this.auth.token}`
      }
    };
  }

  public list(entry: any, status: boolean, sort: string, direction: string) {
    return this.firestore.collection<News>('news', ref => {
      let query: CollectionReference | Query = ref;

      query = query.where('published', '==', status)
        .orderBy(sort, 'desc');

      if (entry) {
        if (direction === 'before') {
          query = query.endBefore(entry).limitToLast(20);
        } else {
          query = query.startAfter(entry).limit(20);
        }
      } else {
        query = query.limit(20);
      }

      return query;
    }).get();
  }

  public getBySlug(slug: string) {
    return this.firestore.collection<News>('news', ref => {
      let query: CollectionReference | Query = ref;

      query = query.where('slug', '==', slug).limit(1);

      return query;
    }).get();
  }

  public getNewsletter() {
    return this.firestore.collection<News>('news', ref => {
      return ref.where('newsletter', '==', true)
        .where('published', '==', true)
        .orderBy('date', 'desc');
    }).get();
  }


  public getById(id: string) {
    return this.firestore.collection('news').doc(id).get();
  }

  public update(id: string, data: any) {
    return this.firestore.collection('news').doc(id).update(data);
  }

  public create(id: string, data: any) {
    return this.firestore.collection('news').doc(id).set(data);
  }

  public delete(id: string) {
    return this.firestore.collection('news').doc(id).delete();
  }

  public getNews(id: string) {
    return this.http.get(`${this.url}/get/${id}`, this.options);
  }

  public togglePublish(id: string, published: boolean) {
    let data = {
      published: !published
    };

    return this.firestore.collection('news').doc(id).update(data);
  }

  public toggleHighlight(id: string, highlightType: string, currentStatus: boolean) {
    let data = {};

    if (highlightType === 'home') {
      data = {
        highlight_home: !currentStatus
      };
    } else {
      data = {
        highlight_news: !currentStatus
      }
    }

    return this.firestore.collection('news').doc(id).update(data);
  }

  public toggleNewsletter(id: string, newsletter: boolean) {
    let data = {
      newsletter: !newsletter
    };

    return this.firestore.collection('news').doc(id).update(data);
  }
}
